import * as settlementsService from '@/services/settlements-api.service';
import { camelizeKeys } from 'humps';
import { 
  SETTLEMENTS_ERROR,
  SETTLEMENTS_SUCCESS,
  SETTLEMENTS_LOADING,
  SETTLEMENT_CREATION_SET_SPONSOR_SLUG,
  SETTLEMENT_CREATION_SET_DATE_FROM,
  SETTLEMENT_CREATION_SET_DATE_TO,
  SETTLEMENT_CREATION_SET_SPONSOR_COMPLETE,
  SELECT_SETTLEMENT_FOR_DETAIL,
  SET_SETTLEMENT_DETAIL,
  CLEAN_SETTLEMENT_DETAIL,
  SETTLEMENT_CREATION_BACK_STEP,
  SETTLEMENT_CREATION_NEXT_STEP,
  SET_PENDING_AUTHORIZATIONS,
  SET_SETTLEMENT_ID,
  CLEAR_SETTLEMENT_CREATION,
  SET_CLAIMS,
  CLEAR_CLAIMS,
  SET_EXCLUDED_CLAIMS,
  CLEAR_EXCLUDED_CLAIMS,
  COMPLETE_ADD_AUTHORIZATIONS_STEP,
  SET_SETTLEMENT_CREATION_RESULT
}from '@/store/mutation-types'

const getSettlements = async({ commit }, filters) => {
  commit(SETTLEMENTS_LOADING, true)
  try{
    const response = await settlementsService.getSettlements(filters);
    commit(SETTLEMENTS_SUCCESS, camelizeKeys(response.data))
    commit(SETTLEMENTS_LOADING, false)
  }catch(error){
    commit(SETTLEMENTS_ERROR, error)
    commit(SETTLEMENTS_LOADING, false)
  }
}

const setSponsorSlug = ({commit}, sponsorSlug) => {
  commit(SETTLEMENT_CREATION_SET_SPONSOR_SLUG, sponsorSlug)
}

const setDateFrom = ({commit}, date) => {
  commit(SETTLEMENT_CREATION_SET_DATE_FROM, date)
}

const setDateTo = ({commit}, date) => {
  commit(SETTLEMENT_CREATION_SET_DATE_TO, date)
}

const setSponsorSelectionComplete = ({ commit }, complete) => {
  commit(SETTLEMENT_CREATION_SET_SPONSOR_COMPLETE, complete)
}

const selectSettlement = ({ commit }, settlement) => {
  commit(SELECT_SETTLEMENT_FOR_DETAIL, settlement)
}

const getDetail = async({ commit }, filters) => {
  commit(SETTLEMENTS_LOADING, true)
  try{
    const response = await settlementsService.getSettlementDetail(filters);
    commit(SET_SETTLEMENT_DETAIL, camelizeKeys(response.data))
    commit(SETTLEMENTS_LOADING, false)
  }catch(error){
    commit(SETTLEMENTS_ERROR, error)
    commit(SETTLEMENTS_LOADING, false)
  }
}

const cleanSettlementDetail = ({ commit }) => {
  commit(CLEAN_SETTLEMENT_DETAIL)
}

const backStep = ({commit})=> {
  commit(SETTLEMENT_CREATION_BACK_STEP)
}

const nextStep = ({commit})=> {
  commit(SETTLEMENT_CREATION_NEXT_STEP)
}

const setPendingAuthorizations = async ({ commit }, filters) => {
  commit(SETTLEMENTS_LOADING, true);
  try{
    const response = await settlementsService.getPendingAuthorizations(filters);
    commit(SET_PENDING_AUTHORIZATIONS, camelizeKeys(response.data));
    commit(SETTLEMENTS_LOADING, false);
  }catch(error){
    commit(SETTLEMENTS_ERROR, error);
    commit(SETTLEMENTS_LOADING, false);
  }  
}

const setSettlementId = async ({ commit }, sponsorSlug) => {
  commit(SETTLEMENTS_LOADING, true);
  commit(SET_SETTLEMENT_CREATION_RESULT, "")
  try{
    const response = await settlementsService.setSettlementId(sponsorSlug);
    commit(SET_SETTLEMENT_CREATION_RESULT, "SUCCESS")
    commit(SET_SETTLEMENT_ID, camelizeKeys(response.data));
    commit(SETTLEMENTS_LOADING, false);
  }catch(error){
    commit(SET_SETTLEMENT_CREATION_RESULT, "ERROR")
    commit(SETTLEMENTS_ERROR, error);
    commit(SETTLEMENTS_LOADING, false);
  }
}

const clearSettlement = ({ commit }) => {
  commit(CLEAR_SETTLEMENT_CREATION)
}

const setClaims = async ({commit, state}) => {
  commit(SETTLEMENTS_LOADING, true);
  commit(SET_SETTLEMENT_CREATION_RESULT, "")
  let filters = {
    settlementId: state.createSettlement.settlementId.id,
    claimIds: state.createSettlement.includedClaims.map(item => item.id),
    dateFrom: state.createSettlement.dates.from,
    dateTo: state.createSettlement.dates.to,
    excludedClaimIds: state.createSettlement.excludedClaims.map(item => item.id)
  }

  let body = {}
  if(filters.claimIds.length > 0){
    body = {
      settlementId: filters.settlementId,
      params: {
        claimIds: filters.claimIds
      }
    }
  }
  else{
    body = {
      settlementId: filters.settlementId,
      params: {
          searchCriteria: {
          dateFrom: filters.dateFrom,
          dateTo: filters.dateTo,
          excludedClaimIds: filters.excludedClaimIds
        }
      }
    }
  }

  try{
    await settlementsService.setClaims(body);
    commit(SET_SETTLEMENT_CREATION_RESULT, "SUCCESS")
    commit(SETTLEMENTS_LOADING, false);
  }catch(error){
    commit(SET_SETTLEMENT_CREATION_RESULT, "ERROR")
    commit(SETTLEMENTS_ERROR, error);
    commit(SETTLEMENTS_LOADING, false);
  }
}

const setIncludedClaim = ({commit}, payload) => {
  commit(SET_CLAIMS, payload)
}

const setExcludedClaim = ({commit}, payload) => {
  commit(SET_EXCLUDED_CLAIMS, payload)
}

const clearIncludedClaims = ({commit}) => {
  commit(CLEAR_CLAIMS)
}

const clearExcludedClaims = ({commit}) => {
  commit(CLEAR_EXCLUDED_CLAIMS)
}

const setAddAuthorizationsComplete = ({ commit }, complete) => {
  commit(COMPLETE_ADD_AUTHORIZATIONS_STEP, complete)
}

export default { 
  getSettlements,
  setSponsorSlug,
  setDateFrom,
  setDateTo,
  setSponsorSelectionComplete,
  selectSettlement,
  getDetail,
  cleanSettlementDetail,
  backStep,
  nextStep,
  setPendingAuthorizations,
  setSettlementId,
  clearSettlement,
  setClaims,
  setIncludedClaim,
  clearIncludedClaims,
  setExcludedClaim,
  clearExcludedClaims,
  setAddAuthorizationsComplete
}